<template>

  <FornitoriDogane />
 
</template>

<script>
import FornitoriDogane from '../components/pratiche/FornitoriDogane.vue'

export default {
  components: {
    FornitoriDogane

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

